<template>
  <div
    :class="[
      'plan-row-item__price-wrapper',
      showDiscountBadge && plan.user_receives_discount && 'plan-row-item__price-wrapper--discount',
    ]"
  >
    <div
      v-if="showDiscountBadge && plan.user_receives_discount"
      class="plan-row-item__neon-wrapper"
    >
      <div class="plan-row-item__neon-content">
        <div class="plan-row-item__neon-text">YOU SAVE $100</div>
      </div>
    </div>
    <div class="plan-row-item__price">
      {{ `$${price}` }}
      <span class="plan-row-item__price-term">{{ term }}</span>
    </div>
    <span
      v-if="showDiscountBadge && plan.user_receives_discount"
      class="plan-row-item__price-no-discount"
    >
      Full price {{ priceFull }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CONSTANTS from '@/constants'

const { PLANS } = CONSTANTS

export default {
  name: 'PlanRowItemPrice',
  props: {
    plan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isBoogoCard: this.plan.merchant_id === PLANS.INE_PREMIUM_BOOGO_2Y,
    }
  },
  computed: {
    ...mapGetters({
      isBlackFridayActive: 'featureFlags/isBlackFridayActive',
      isLeapYearPromoActive: 'featureFlags/isLeapYearPromoActive',
    }),
    price() {
      const priceToShow = this.plan.user_receives_discount
        ? this.plan.discounted_price_cents
        : this.plan.price_cents
      return priceToShow / 100
    },
    priceFull() {
      return `$${this.plan.price_cents / 100}`
    },
    term() {
      if (this.isBoogoCard) return '/2 years'
      return `/${this.plan.term}`
    },
    showDiscountBadge() {
      return this.isBlackFridayActive || this.isLeapYearPromoActive
    },
  },
}
</script>

<style lang="scss" scoped>
.plan-row-item {
  &__price {
    font-weight: 700;
    font-size: 54px;
    line-height: 66px;
    display: flex;
    align-items: center;
    color: var(--white);
    &-term {
      color: var(--dusty-grey);
      font-weight: 450;
      font-size: rem(12px);
      line-height: 14px;
      margin-left: 5px;
    }
    &-wrapper {
      padding-bottom: 30px;
      margin-bottom: 30px;
      border-bottom: 1px solid var(--mid-gray-translucid);
      @include mobile {
        padding-bottom: 40px;
        margin-bottom: 40px;
      }
      &--discount {
        padding-bottom: 11px;
        @include mobile {
          padding-bottom: 21px;
        }
      }
    }
    &-no-discount {
      color: var(--light-blue-gray);
      font-size: rem(12px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(14px);
    }
  }
  &__neon {
    &-wrapper {
      background-color: var(--cod-gray);
      background: url('../../assets/images/backgrounds/bl-bundle-price-bg.png');
      background-repeat: no-repeat;
      background-size: 65px;
      border-radius: 84.5px;
      height: 65px;
      width: 65px;
      position: absolute;
      left: 70%;
      top: 120px;
      @include mobile {
        left: 75%;
        top: -6%;
      }
      @include tablet-ipad-air-and-mini-portrait {
        left: 70%;
        top: 115px;
      }
      @include tablet-ipad-pro {
        left: 70%;
        top: 160px;
      }
      @include desktop {
        left: 70%;
        top: 125px;
      }
    }
    &-content {
      height: 87px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: -10px;
      left: 5px;
    }
    &-text {
      font-size: rem(12px);
      font-weight: 700;
      line-height: rem(10px);
      text-align: center;
      width: 55px;
    }
  }
}
</style>
